import { ClientComponentLogger, LogErrorParams } from '../../client-component-logger';

export abstract class BaseComponent2 {
    public abstract rootSelector: string;
    public rootElement?: HTMLElement;

    protected logger?: ClientComponentLogger;

    /**
 *
 *
 *
 *
 */
    public async onFirstPageLoadOncePerComponentType(): Promise<unknown> {
        return;
    }

    /**
 *
 *
 */
    public async init(): Promise<unknown> {
        return;
    }

    /**
 *
 *
 *
 *
 *
 */
    public async onReloadComponentEvent(): Promise<unknown> {
        return;
    }

    public async setLogger(logger: ClientComponentLogger) {
        this.logger = logger;
    }

    public setRootElement(element: HTMLElement) {
        this.rootElement = element;
    }

    /**
 *
 */
    protected getRootElement(): HTMLElement {
        if (!this.rootElement) {
            throw new Error(`rootElement for '${this.rootSelector}' was not set`);
        }
        return this.rootElement;
    }

    /**
 *
 *
 */
    protected getChildElement<T extends HTMLElement>(selector: string): T | undefined {
        return this.rootElement?.querySelector<T>(selector) || undefined;
    }

    /**
 *
 *
 */
    protected getChildElements<T extends HTMLElement>(selector: string): T[] {
        return Array.from(this.getRootElement().querySelectorAll<T>(selector));
    }

    /**
 *
 */
    protected isPresent(): boolean {
        return this.rootElement ? document.body.contains(this.rootElement) : false;
    }

    /**
 *
 */
    protected hide() {
        this.getRootElement().classList.add('pl_hidden');
    }

    /**
 *
 */
    protected show() {
        this.getRootElement().classList.remove('pl_hidden');
    }

    /**
 *
 */
    protected hideChild(selector: string) {
        const element = this.getChildElement(selector);
        element?.classList.add('pl_hidden');
    }

    /**
 *
 */
    protected showChild(selector: string) {
        const element = this.getChildElement(selector);
        element?.classList.remove('pl_hidden');
    }

    /**
 *
 *
 *
 */
    protected logError(params: LogErrorParams) {
        this.logger?.logError(params) || console.error(params);
    }
}
